import React from 'react';
import cx from 'classnames';

const defaultStyles = 'pt-2 pb-6 flex justify-center w-full';

const SearchResultsEmpty = ( {loading, className} ) =>
    <div className={cx( className, {
        [defaultStyles]: !className
    } )}>
        {loading ? '...' : 'No Results'}
    </div>;

export default SearchResultsEmpty;
